module.exports = __webpack_public_path__ + "img/3-5s.be25595f.jpg";